import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

/** The project's test files (shared by the Test files card and the script editor's file pickers). */
export const perfFilesKey = (projectId: string) => ['perf-files', projectId];
export const usePerfFiles = (projectId: string) => useQuery({ queryKey: perfFilesKey(projectId), queryFn: () => api.perfFiles(projectId) });
